













import { Vue, Prop, Component } from 'vue-property-decorator';

import Logo from '@/components/common/Logo.vue';

@Component({
  components: { Logo }
})
export default class TopNavBar extends Vue {
  @Prop() public showSideBar!: boolean;
  @Prop() public showHideSideBar!: any;
}
